import { matchPath, useLocation } from 'react-router-dom'

import { mpCardRoutes } from 'common/mpCardRoutes'

type CardPageMode = 'create' | 'edit' | 'import' | 'unknown'

export const useCardPageMode = (): {
  mode: CardPageMode
  id?: string
  productId?: string
} => {
  const {pathname} = useLocation()

  if (pathname === mpCardRoutes.newCard.template) {
    return {mode: 'create'}
  }

  const importMatch = matchPath<{id?: string, productId?: string}>(pathname, {
    path: mpCardRoutes.import.template,
    exact: true
  })

  if (importMatch?.params.id && importMatch.params.productId) {
    return {
      mode: 'import',
      id: importMatch.params.id,
      productId: importMatch.params.productId
    }
  }

  const editMatch = matchPath<{id?: string}>(pathname, {
    path: mpCardRoutes.card.template,
    exact: true
  })

  if (editMatch?.params.id) {
    return {
      mode: 'edit',
      id: editMatch.params.id,
      productId: editMatch.params.id
    }
  }

  return {mode: 'unknown'}
}

